import { useNavigate } from 'react-router-dom'
import { RhyBusButton } from '@rhybus/button'

export default function BackButton() {
    const navigate = useNavigate()

    return (
        <RhyBusButton
            label="Back"
            leftIcon="icon-rb-arrow-left color-primary bold font-12"
            variant="primary"
            ariaLabel="Back"
            onClick={() => navigate('/trainings')}
            style={{
                '--rb-btn-bg': '#fff',
                '--rb-btn-border': '#D2D2D2',
                '--rb-btn-text': '#000',
                '--rb-btn-hover-border': '#D2D2D2'
            }}
        />
    )
}
